module.exports = __webpack_public_path__ + "img/list_CommIllustration_03.2160bb58.jpeg";